module.exports = __webpack_public_path__ + "static/media/logob.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logob.png
// module id = 75
// module chunks = 0